<!-- 微博-代理商 -->
<template>
<div>
	<!-- 表头 -->
	<div class="table-th" :style="{'width': table_scroll_width_c - 60 + 'px'}">
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
			<div class="table-th-cell" 
			:style="{'width':item.width + 'px',}">
				{{item.title}}
			</div>
		</div>
	</div>
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in ToutiaoList" :key="index" class="table-td"  :style="{'width': table_scroll_width_c -60 + 'px'}">
		<template v-for="(z_tem,z_ndex) in rableTitle">
			<div v-if="z_tem.type !='auth' && z_tem.type != 'effective_status' && z_tem.type != 'refresh_expires_in' && z_tem.type != 'cz'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type]}}
			</div>
			<!-- 是否授权 -->
			<div v-else-if="z_tem.type == 'auth'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type] == 1?'是':'否'}}
			</div>
			<!-- 计划状态 -->
			<div v-else-if="z_tem.type == 'effective_status'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type] | shStatusFilters}}
			</div>
			<!-- 授权有效期 -->
			<div v-else-if="z_tem.type == 'refresh_expires_in'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type]}} <span v-if="item.refresh_expires_text" style="color: red;">（{{item.refresh_expires_text}}）</span>
			</div>
			<!-- 操作 -->
			<div v-else-if="z_tem.type == 'cz'" class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}" 
			@click="tdCz(item,1)" style="cursor: pointer;color: #62a8ea;">
				同步推广账户
			</div>
		</template>
	</div>
	
	<div v-show="ToutiaoList.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width_c + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { accountWBagent, accountWBsync } from '@/request/api'
export default {
	name: 'wbAgentPage_',
	data() {
		return {
			rableTitle: [
				{title:"授权账户名称", width:120, type:"adv_name", }, 
				{title:"账户ID", width:100, type:"adv_id", },
				{title:"微博登陆账户", width:110, type:"account_login", },
				{title:"是否授权", width:90, type:"auth", },
				{title:"授权有效期", width:150, type:"refresh_expires_in", },
				{title:"授权开发者账户", width:120, type:"account_name", },
				// {title:"审核状态", width:100, type:"effective_status", },
				{title:"操作", width:100, type:"cz", },
			],
			tableShowDataBBB: [],
			table_scroll_width_c: 1000,
			ToutiaoList: [], // 开发者账户
			
			search_button_loading: false,
		}
	},
	mounted(){
		let that = this
		// 获取表格信息
		let table_info_c = this.$getTableInfo(that.rableTitle)
		
		that.table_scroll_width_c = table_info_c.table_width
		
		// 代理商账户
		accountWBagent().then(res=>{
			console.log("代理商账户",res);
			if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
				let data = res.data.data.data
				data.forEach(res=>{
					if(res.refresh_expires_in){
						let date = new Date(res.refresh_expires_in)
						let ddd = date.getTime() - Date.now()
						if(ddd > 0 && ddd < 864000000){ // 相差10天内，表示快要过期
							res.refresh_expires_text = "快过期"
						}
						else if(date.getTime() - Date.now() <= 0){
							res.refresh_expires_text = "已过期"
						}
						else { // 表示还有日期，还不会过期
							res.refresh_expires_text = ""
						}
					}
					else {
						res.refresh_expires_text = null
					}
				})
				that.ToutiaoList = res.data.data.data
			}
			else {
				that.ToutiaoList = []
				that.$message.error(`代理商账户-错误：${res.data.msg}`);
			}
		})
		
		// that.searchButton()
	},
	methods:{
		// 搜索
		searchButton(type){
			let that = this
			
			// that.search_button_loading = true
			
			// if(type != '分页'){
			// 	that.selectedData = [] // 已选内容清空
			// }
			
			// if(type == 'button'){
			// 	that.r_page = 1
			// }
			
			
			// 开发者账户
			accountWBagent().then(res=>{
				console.log("开发者账户",res);
				// that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.ToutiaoList = res.data.data.data
				}
				else {
					that.ToutiaoList = []
					that.$message.error(`开发者账户-错误：${res.data.msg}`);
				}
			})
			
		},
		tdCz(item,type){
			let that = this
			if(type == 1){
				that.search_button_loading = true
				accountWBsync({
					appid: item.appid
				}).then(res=>{
					that.search_button_loading = false
					console.log('同步',res);
					that.$message.success(res.data.msg);
				})
			}
		}
	},
	filters: {
		// 审核状态
		shStatusFilters(value){
			let vvv = ""
			if(value == 1){
				vvv = "未授权"
			}
			else if(value == 2){
				vvv = "正常"
			}
			else if(value == 3){
				vvv = "冻结"
			}
			else if(value == 4){
				vvv = "解绑"
			}
			else if(value == 9){
				vvv = "删除"
			}
			
			return vvv
		},
	}
	
}
</script>

<style>
</style>